import { createAction } from 'typesafe-actions';
import { INematodeSurveyType } from '../../../../types/model/masterData/nematode/survey';

export default class MasterDataNematodeNematodeSurveyTypeActions {
    public static setLoading = createAction('MASTER_DATA_NEMATODES_SURVEY_TYPE_SET_LOADING', resolve => (loading : boolean) => resolve(loading));
    public static setList = createAction('MASTER_DATA_NEMATODES_SURVEY_TYPES_SET', resolve => (list : Array<INematodeSurveyType>) => resolve(list));
}